<template>
  <div>
    <pre>
      {{params}}
    </pre>
  </div>
</template>

<script>
// @ is an alias to /src
// import { UnitTextArea, UnitTextField, UnitTag } from "@/components/units";

export default {
  name: "ArchitectureLists",
  data() {
    return {
      doc: {},
    };
  },
  components: {
    // UnitTextArea, UnitTextField, UnitTag 
  },
  props: {
    params: Array,
  },
  methods: {
   
  },
};
</script>
